import { createSlice } from "@reduxjs/toolkit";


export const userDataSlice = createSlice({
    name: 'userData',
    initialState:{},
    reducers: { //modify the selected spot in global state
        setUserData: (currentState, action) => {
            
            return action.payload //action.payload is the new livrasion object (valid, secteur, adresse,comp) sent by the dispatch call

        }
    }
});